import { ibhApiService } from '@hub/bearing-hub/common/api-service';
import * as Sentry from '@sentry/nextjs';
import type { IbhBearingMaterialsDescriptionParams } from '@igus/iglidur-bearing-hub-api/src/data-contracts';

export const fetchMaterialsDescription = async ({ materialCode, locale }: IbhBearingMaterialsDescriptionParams) => {
  try {
    const response = await ibhApiService.bearingMaterialsDescription({ materialCode, locale });
    return response.data;
  } catch (error) {
    Sentry.captureException(error);
    throw new Error(`Could not fetch materials description for materialCode: ${materialCode} and locale: ${locale}`);
  }
};
